import React, { useEffect, useState } from 'react';
import useBrandContext from 'contexts/brand.context';
import useDashboardContext from 'contexts/dashboard.context';
import { POLYGON_COLORS } from 'utils/constants';
import { ReactComponent as HexagonIcon } from 'assets/icons/hexagon.svg';
import { apiService } from 'services/base.service';
import { PolygonType } from 'utils/types';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import { toast } from 'react-toastify';

export default function PreviewBrandPolygon() {
  const { activeBrand } = useBrandContext();
  const { activeCokitchen } = useDashboardContext();

  const [allPolygons, setAllPolygons] = useState<PolygonType[]>([]);
  const [loading, setLoading] = useState(true);

  const selectedCoKitchenId = activeCokitchen.cokitchen_id;

  useEffect(() => {
    if (!selectedCoKitchenId) return;

    const fetchPolygons = async () => {
      setLoading(true);
      try {
        const res = await apiService.get(`internal/cokitchen/polygons/${selectedCoKitchenId}`, {
          isInternal: true
        });
        setAllPolygons(res.data.data || []);
      } catch (error) {
        toast(<ToastMessage type='error' message='Error loading polygons' />);
        setAllPolygons([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPolygons();
  }, [selectedCoKitchenId]);

  const polygonNames = allPolygons?.filter(
    (polygon) => !activeBrand?.excluded_polygon_ids?.includes(polygon.id)
  );

  if (loading) return <p className='p-4 text-gray-500 italic'>Loading polygons...</p>;

  if (!activeBrand.excluded_polygon_ids || polygonNames.length === 0)
    return <p className='p-4 text-gray-500'>No polygons selected or found.</p>;

  return (
    <div className='border border-[#EAEAEB] rounded-xl shadow-md overflow-hidden max-w-full sm:w-[500px]'>
      <div className='flex w-full border-b border-[#EAEAEB] font-semibold text-sm text-gray-5 px-4 py-2'>
        Available Polygons
      </div>

      <ul className='divide-y divide-[#EAEAEB]'>
        {polygonNames.map((polygon, index) => (
          <li key={index} className='px-4 py-4 text-gray-800 flex items-center'>
            <HexagonIcon style={{ color: POLYGON_COLORS[index].color_code }} className='mr-3' />
            {polygon.name}
          </li>
        ))}
      </ul>
    </div>
  );
}
